<template>
<div style="background-color: #f7f8fa">
     <topNav :title="$t('repair_title')" url="/opera/fangT"></topNav>
	<div class="opera-warp" >
			<div class="orderSta clearfix">
				<div class="Num">{{orderInfo.rmno}} </div>
				<div class="sta">
					<span style="color: #D0011B" v-if="orderInfo.chg_sta=='S'">{{$t('repair_staS')}}</span>
					<span style="color: #D0011B" v-if="orderInfo.chg_sta=='O'">{{$t('repair_staO')}}</span>
				</div>
			</div>
			<div class="infoList">
				<div class="info">
					<div class="infoTop">
						<i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('fangTXQ_baseInfo')}}
					</div>
					<ul class="infoContent ">
            <li>{{$t('fangTXQ_rmno')}}:<span class="infoVal">{{orderInfo.rmno}}</span></li>
            <li>{{$t('orderDetail_sta')}}:
              <span class="infoVal"
                    v-if="orderInfo.chg_sta=='S'">{{$t('repair_staS')}}</span>
              <span class="infoVal"
                    v-if="orderInfo.chg_sta=='O'">{{$t('repair_staO')}}</span></li>
            <li>{{$t('repair_begin')}}:<span class="infoVal">{{orderInfo.date_begin | datefomate}}</span></li>
            <li>{{$t('repair_end')}}:<span class="infoVal">{{orderInfo.date_end | datefomate}}</span></li>
          </ul>
				</div>
				<div class="info">
					<div class="infoTop">
						<i class="iconfont icon-changfangxingbiaoqian"></i>
            {{$t('other')}}
					</div>
					<ul class="infoContent">
						<li>{{$t('reason')}}:<span class="infoVal" >{{orderInfo.weixiu_reason}}</span></li>
						<li style="height:auto">{{$t('book_remark')}}:<span class="infoVal" >{{orderInfo.remark}}</span></li>
					</ul>
				</div>
				</div>
		</div>
</div>
</template>

<script>
import moment from 'moment'
export default {
		data(){
			return {
				orderInfo:{}
			}
		},
		mounted(){
			this.$http.post('/mobilepmsapi/reception/getRoomMaintLockInfo',this.$route.query).then(res=>{
				this.orderInfo=res.data.retVal
				console.log(res.data.retVal);
				console.log(this.$route.query);
			})

		},
		methods:{

		},
		filters:{
			datefomate(value){
				return moment(value, "YYYY-MM-DD HH:mm:ss").format('YYYY/MM/DD HH:mm')
			}

		},
		components:{

		}
	}
</script>

<style lang='less' scoped >
.opera-warp{
	margin:10px auto;
	width: 96%;
	background-color: #fff;
	.orderSta{
		background-color: #D2D6DE;
		height: 26px;
		line-height: 26px;
		color:#333;
		margin-bottom: 15px;
		.Num{
			float: left;
			margin-left: 8px;
		}
		.sta{
			float: right;
			margin-right: 8px;
		}
	}
	.infoList{
		.info{
			padding: 0px 0px 15px;
			.infoTop{
				padding: 0 18px;
				position: relative;
				height: 20px;
				line-height: 20px;
				.icon-changfangxingbiaoqian{
					position: absolute;
					font-size: 12px;
					left: 0;
					top:1px;
					color:#f6a624;
				}
			}
			.infoContent{
				margin: 0 20px;
				padding: 10px 0;
				border-bottom: 1px dashed #ddd;
				li{
					height: 20px;
					line-height: 20px;
					.infoVal{
						margin-left: 8px;
					}

				}
				&.twocol{
					overflow: hidden;
						li{
							width: 50%;
							float: left;
						}
					}
			}

		}

	}

}

</style>



// WEBPACK FOOTER //
// repair.vue?147d59a4